export enum UserRole {
    SALES_MANAGER = 'SALES_MANAGER',
    SALES_LEAD = 'SALES_LEAD'
}

export enum CrmPermission {
    ASSIGN_CUSTOMER_SALES_MANAGER = 'ASSIGN_CUSTOMER_SALES_MANAGER',
    MANAGE_OTHER_SALES_MANAGER_SUBSTITUTIONS = 'MANAGE_OTHER_SALES_MANAGER_SUBSTITUTIONS',
    EMAIL_TEMPLATE_EDITOR = 'EMAIL_TEMPLATE_EDITOR'
}

export const CRM_ROLE_LABELS: Record<UserRole, string> = {
    [UserRole.SALES_LEAD]: "Müügijuht",
    [UserRole.SALES_MANAGER]: "Müügimees"
};

export interface IRoleAssignment {
    roleCode: string;
    permissions: string[];
}

export interface IUser {
    id: number ;
    email: string | null;
    name: string;
    adminActive: boolean | null;
    adminAccess: boolean | null;
    personalIdentificationCode: string | null;
    lastLogin: string | null;
    dateModified: string | null;
    roles: string[];
    permissions: string[];
    approvalLimit?: number;
}

export enum IUsersSortFields {
    ID = "ID",
    NAME = "NAME"
}

export interface IUsersSearchBarProps {
    openAddUsersModal: () => void;
    onFilter: (change: { searchQuery: string }) => void;
}

export interface IEditUserModalProps {
    rejectCloseHandler: () => void;
    submitCloseHandler: () => void;
    editingUser: IUser;
}

export interface IUserForm {
    email: string;
    name: string;
    adminActive: boolean;
    password: string;
    passwordCheck: string;
}

export interface IEditUserForm {
    adminActive: boolean;
    crmRole: UserRole | undefined;
    crmPermissions: string[];
    approvalLimit: number | undefined;
}